export default "__VITE_ASSET__BmL5LxLc__"